<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="属性">
              <a-input placeholder="请输入属性" v-model="queryParam.configCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="属性名称">
              <a-input placeholder="请输入属性名称" v-model="queryParam.configName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="描述">
              <a-input placeholder="请输入描述" v-model="queryParam.configDesc"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('系统设置')">导出</a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        ref="superQueryModal"
        @handleSuperQuery="handleSuperQuery"
      ></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down"/></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="valueSlot" slot-scope="text, record">
          <span v-if="record.valueType === 'switch'">
            <a-tag v-if="text == '1'" color="#87d068">
              true
            </a-tag>
            <a-tag v-else color="#f50">
              false
            </a-tag>
          </span>
          <img
            v-else-if="record.valueType === 'image'"
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width:80px;font-size: 12px;font-style: italic;margin: 0 auto;"
          />
          <a-button
            v-else-if="record.valueType === 'file'"
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)"
          >
            下载
          </a-button>
          <span v-else>{{ text }}</span>
        </template>
        <template slot="enableSlot" slot-scope="text, record">
          <j-switch v-model="record.enabled" :options="[1, 0]" @change="enabledConfig(record)"></j-switch>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <common-sys-setting-config-modal ref="modalForm" @ok="modalFormOk"></common-sys-setting-config-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import CommonSysSettingConfigModal from './modules/CommonSysSettingConfigModal'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

export default {
  name: 'CommonSysSettingConfigList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    CommonSysSettingConfigModal
  },
  data() {
    return {
      description: '系统设置管理页面',
      // 表头
      columns: [
        {
          title: '属性',
          align: 'center',
          sorter: true,
          width: 100,
          dataIndex: 'configCode'
        },
        {
          title: '属性名称',
          align: 'center',
          sorter: true,
          dataIndex: 'configName'
        },
        {
          title: '属性值',
          align: 'center',
          sorter: true,
          dataIndex: 'configValue',
          scopedSlots: { customRender: 'valueSlot' }
        },
        // {
        //   title: '属性类型',
        //   align: 'center',
        //   sorter: true,
        //   dataIndex: 'configType'
        // },
        // {
        //   title: '值类型',
        //   align: 'center',
        //   sorter: true,
        //   dataIndex: 'valueType_dictText'
        // },
        {
          title: '描述',
          align: 'center',
          sorter: true,
          dataIndex: 'configDesc'
        },
        {
          title: '是否生效',
          align: 'center',
          sorter: true,
          dataIndex: 'enabled',
          width: 80,
          scopedSlots: { customRender: 'enableSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/system/setting/list',
        delete: '/system/setting/delete',
        deleteBatch: '/system/setting/deleteBatch',
        exportXlsUrl: '/system/setting/exportXls',
        importExcelUrl: 'system/setting/importExcel'
      },
      dictOptions: {},
      superFieldList: []
    }
  },
  created() {
    this.$set(this.dictOptions, 'enabled', [
      { text: '是', value: 'Y' },
      { text: '否', value: 'N' }
    ])
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    enabledConfig(record) {},
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'configCode', text: '属性', dictCode: '' })
      fieldList.push({ type: 'string', value: 'configName', text: '属性名称', dictCode: '' })
      fieldList.push({ type: 'string', value: 'configValue', text: '属性值', dictCode: '' })
      fieldList.push({ type: 'string', value: 'configType', text: '属性类型', dictCode: '' })
      fieldList.push({ type: 'string', value: 'valueType', text: '值类型', dictCode: '' })
      fieldList.push({ type: 'string', value: 'configDesc', text: '描述', dictCode: '' })
      fieldList.push({ type: 'switch', value: 'enabled', text: '是否生效' })
      this.superFieldList = fieldList
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
